export default "__VITE_ASSET__b4724745__"